// accounts
export const FIND_ORGANIZATION = 'accounts/FIND_ORGANIZATION';

// auth
export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const LOGIN = 'auth/LOGIN';
export const LOGIN_ORGANIZATION = 'auth/LOGIN_ORGANIZATION';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const SIGNUP = 'auth/SIGNUP';
export const UPDATE_PROFILE = 'auth/UPDATE_PROFILE';
export const UPLOAD_COVER_IMAGE = 'auth/UPLOAD_COVER_IMAGE';
export const UPLOAD_LICENSE_IMAGE = 'auth/UPLOAD_LICENSE_IMAGE';
export const UPLOAD_LOGO = 'auth/UPLOAD_LOGO';
export const VERIFY_EMAIL = 'auth/VERIFY_EMAIL';

// chats
export const LIST_PRESENCES = 'chats/LIST_PRESENCES';
export const SEND_MESSAGE = 'chats/SEND_MESSAGE';
export const MESSAGE_READ = 'chats/MESSAGE_READ';

// ui
export const CLEAR_CONFIRM_MESSAGE = 'ui/CLEAR_CONFIRM_MESSAGE';
export const CLEAR_HEADER_TITLE = 'ui/CLEAR_HEADER_TITLE';
export const CLEAR_HELP_CONTENT = 'ui/CLEAR_HELP_CONTENT';
export const CLEAR_ORDER_CART = 'ui/CLEAR_ORDER_CART';
export const CLEAR_SEARCH_CONTENT = 'ui/CLEAR_SEARCH_CONTENT';
export const CLEAR_SIDEBAR_ITEMS = 'ui/CLEAR_SIDEBAR_ITEMS';
export const CLEAR_SIDEBAR_OPEN = 'ui/CLEAR_SIDEBAR_OPEN';
export const GLOBAL_NOTIFICATION = 'ui/GLOBAL_NOTIFICATION';
export const SET_CONFIRM_ACTION = 'ui/SET_CONFIRM_ACTION';
export const SET_CONFIRM_MESSAGE = 'ui/SET_CONFIRM_MESSAGE';
export const SET_HEADER_TITLE = 'ui/SET_HEADER_TITLE';
export const SET_HELP_CONTENT = 'ui/SET_HELP_CONTENT';
export const SET_HOT_NOTIFICATION = 'ui/SET_HOT_NOTIFICATION';
export const SET_LOCALE = 'ui/SET_LOCALE';
export const SET_ORDER_CART = 'ui/SET_ORDER_CART';
export const SET_PAGINATION = 'ui/SET_PAGINATION';
export const SET_PRINT_CONTENT = 'ui/SET_PRINT_CONTENT';
export const SET_SCROLL_TOP = 'ui/SET_SCROLL_TOP';
export const SET_SEARCH_CONTENT = 'ui/SET_SEARCH_CONTENT';
export const SET_SIDEBAR_ITEMS = 'ui/SET_SIDEBAR_ITEMS';
export const SET_SIDEBAR_OPEN = 'ui/SET_SIDEBAR_OPEN';
export const CLEAR_FILTER_CATEGORY = 'ui/CLEAR_FILTER_CATEGORY';
export const SET_FILTER_CATEGORY = 'ui/SET_FILTER_CATEGORY';

// credits
export const PURHCASE_CREDITS = 'credits/PURHCASE_CREDITS';
export const TRANSFER_CREDITS = 'credits/TRANSFER_CREDITS';
export const WITHDRAW_CREDITS = 'credits/WITHDRAW_CREDITS';

// market place
export const GET_PUBLIC_INFO = 'market-place/GET_PUBLIC_INFO';
export const GET_MARKET_PLACE_DETAILS = 'market-place/GET_MARKET_PLACE_DETAILS';

// shop
// export const GET_SHOP = 'shop/GET_SHOP';
// export const GET_SHOP_PUBLIC = 'shop/GET_SHOP_PUBLIC';
export const SHOP_HAS_DELIVERY_FEE_ORDER = 'shop/HAS_DELIVERY_FEE_ORDER';

// options
export const LIST_BRANDS = 'options/LIST_BRANDS';
export const LIST_FAQS = 'options/LIST_FAQS';
export const LIST_FEATURES = 'options/LIST_FEATURES';
export const LIST_GLOBALS = 'options/LIST_GLOBALS';
export const LIST_PACKS = 'options/LIST_PACKS';
export const LIST_PERMISSIONS = 'options/LIST_PERMISSIONS';
export const LIST_ROLES = 'options/LIST_ROLES';
export const LIST_TAGS = 'options/LIST_TAGS';
export const LIST_TEAM_MEMBERS = 'options/LIST_TEAM_MEMBERS';
export const LIST_TUTORIALS = 'options/LIST_TUTORIALS';
export const LIST_UOMS = 'options/LIST_UOMS';
export const DAILY_SALES_PURCHASES = 'options/DAILY_SALES_PURCHASES';
export const MONTHLY_PURCHASES = 'options/MONTHLY_PURCHASES';
export const MONTHLY_PURCHASES_LIST = 'options/MONTHLY_PURCHASES_LIST';
export const MONTHLY_SALES = 'options/MONTHLY_SALES';
export const MONTHLY_SALES_LIST = 'options/MONTHLY_SALES_LIST';
export const LIST_HOME_SECTIONS = 'options/LIST_HOME_SECTIONS';
export const LIST_ABOUT_PAGE = 'options/LIST_ABOUT_PAGE';


// orders
export const CONFIRM_ALL_INVOICES = 'orders/CONFIRM_ALL_INVOICES';
export const PACK_LIST = 'orders/PACK_LIST';
export const PICK_LIST = 'orders/PICK_LIST';
export const WAREHOUSE_LIST = 'orders/WAREHOUSE_LIST';
export const SEND_ORDER_UPDATE_EMAIL = 'orders/SEND_ORDER_UPDATE_EMAIL';
export const HAS_DELIVERY_FEE_ORDER = 'orders/HAS_DELIVERY_FEE_ORDER';
export const MARK_AS_PAID = 'orders/MARK_AS_PAID';

// members
export const CREATE_MEMBER = 'members/CREATE_MEMBER';
export const DELETE_MEMBER = 'members/DELETE_MEMBER';
export const GET_MEMBERS = 'members/GET_MEMBERS';
export const REINVITE_MEMBER = 'members/REINVITE_MEMBER';

// products
export const GET_PRODUCTS = 'products/GET_PRODUCTS';
export const GET_PRODUCT_NAMES = 'products/GET_PRODUCT_NAMES';
export const GET_PRODUCT_SUBNAMES = 'products/GET_PRODUCT_SUBNAMES';

// buyers
export const BUYERS_PAYMENT_DETAIL = 'buyers/paymentDetail';

// notifications
export const STORE_NOTIFICATIONS_LIST = 'notifications/STORE_NOTIFICATIONS_LIST';
export const APP_NOTIFICATIONS_LIST = 'notifications/APP_NOTIFICATIONS_LIST';
export const MARK_NOTIFICATION_AS_READ = 'notifications/MARK_NOTIFICATION_AS_READ';

// social contacts
export const CREATE_SOCIAL_CONTACTS = 'socialContacts/CREATE_SOCIAL_CONTACTS';
export const LIST_SOCIAL_CONTACTS = 'socialContacts/LIST_SOCIAL_CONTACTS';
